import { useSearchParams } from "react-router-dom";
import DietaryPreferenceService from "../../../services/DietaryPreferenceService";
import { DietaryPreference } from "../../../models";
import { useEffect, useState } from "react";
import { CreateDietaryPreference } from "./ui/buttons";
import DietaryPreferencesTable from "./ui/dietary-preferences-table";
import DietaryPreferencesSkeleton from "./skeleton/dietary-preferences-skeleton";

export default function DietaryPreferencesPage() {
    const [searchParams] = useSearchParams();
       const api = new DietaryPreferenceService();
       const [dietaryPreferences,setDietaryPreferences] = useState<DietaryPreference[]>([]);
       const [loading, setLoading] = useState(true);

       useEffect(() => {     
         fetchDietaryPreferences();
       }, [searchParams.get("reload")]);
       
       const fetchDietaryPreferences = async () => {
         const data = await api.getDietaryPreferences();
         setDietaryPreferences(data);
         setLoading(false);     
       };
        
     return (
       <div className="w-full">
         <div className="flex w-full items-center justify-between">
           <h1 className={` text-2xl`}>Dietary Preferences</h1>
         </div>
         <CreateDietaryPreference />
         {loading ? <DietaryPreferencesSkeleton /> : <DietaryPreferencesTable dietaryPreferences={dietaryPreferences} />}
       </div>
     );
   
}



